<template>
  <svg
    id="Tramitados"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 236.519 205.75"
  >
    <g
      id="Retângulo_28"
      data-name="Retângulo 28"
      transform="translate(0 29.75)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <rect
      id="Retângulo_29"
      data-name="Retângulo 29"
      width="109"
      height="120"
      transform="translate(79 24.75)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-share"
      data-name="Icon awesome-share"
      d="M181.191,59.028,117.878,4.355A8.64,8.64,0,0,0,103.6,10.889v28.8C45.819,40.348,0,51.928,0,106.688c0,22.1,14.238,44,29.977,55.445,4.911,3.572,11.911-.911,10.1-6.7C23.766,103.266,47.814,89.418,103.6,88.615V120.24a8.639,8.639,0,0,0,14.276,6.534L181.191,72.1A8.637,8.637,0,0,0,181.191,59.028Z"
      transform="translate(52.339 -2.25)"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
